import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { InputProps as StandardInputProps } from '@material-ui/core/Input';

interface VseHtmlInputProps extends StandardInputProps {
}

const useStyles = makeStyles<Theme, { rows: number }>(() => ({
  input: {
    display: 'none',
  },
  content: {
    height: 'auto',
    minHeight: (props) => `${(props.rows * 1.1875)}em`,
    '& > p:first-child ': {
      marginTop: 'auto',
    },
    '& > p:last-child ': {
      marginBottom: 'auto',
    },
  }
}));

export function VseHtmlInput(props: VseHtmlInputProps) {
  const {
    value = "",
    rows = 1,
    onChange,
  } = props;
  const classes = useStyles({ rows: rows as number });

  return (
    <React.Fragment>
      <textarea
        className={classes.input}
        ref={props.inputRef}
        value={value as string}
        onChange={onChange}
      />
      <div className={clsx(classes.content, (rows === 1) && 'MuiInputBase-input', (rows === 1) && 'MuiInput-input')} dangerouslySetInnerHTML={{ __html: value as string }} />
    </React.Fragment>
  );
}
